import { LegacyPagePaths } from "App/routes/paths";

import { convoIntelPathResources } from "./convoIntelPaths";

/**
 * Convo Intel metadata source of truth.
 *
 * Current behavior:
 * - Core sub-nav titles/descriptions are aligned with Spotlight matching.
 * - `_PATCH` values are temporary copy overrides for header/sub-nav integration gaps.
 *
 * Direction:
 * - Merge to one product-approved metadata set so Spotlight and in-page navigation use the same copy.
 */

export const CONVO_INTEL_SUB_NAV_TITLES = {
    [convoIntelPathResources.recordings]: "Recordings & Transcripts",
    [convoIntelPathResources.observability]: "Observability",
    [convoIntelPathResources.moments]: "Moments",
    [convoIntelPathResources.customAnalysis]: "Custom AI Analysis",
    [convoIntelPathResources.scorecards]: "Scorecards Templates",
    [convoIntelPathResources.insights]: "Transcript Insights",
    [convoIntelPathResources.agentChats]: "Web Transcripts",
} as const;

export const CONVO_INTEL_PAGE_CONFIG_PATCH = {
    [convoIntelPathResources.recordings]: "Recording Transcript Page",
    [LegacyPagePaths.transcripts]: "Recordings And Transcripts",
    [convoIntelPathResources.insights]: "Conversation Intelligence Insights",
} as const;

export const CONVO_INTEL_PAGE_DESCRIPTIONS = {
    [convoIntelPathResources.recordings]: "Call transcript management and analysis system.",
    [convoIntelPathResources.observability]: "Conversation observability and monitoring dashboard.",
    [convoIntelPathResources.moments]: "Transcript moment tracking and monitoring tools.",
    [convoIntelPathResources.customAnalysis]: "Custom AI analysis configuration for transcripts.",
    [convoIntelPathResources.scorecards]: "Quality assurance and scoring templates for transcript evaluation.",
    [convoIntelPathResources.insights]: "Transcript analysis and insights dashboard.",
} as const;

// Header/sub-nav title overrides used where page labels differ from base metadata.
export const CONVO_INTEL_SUB_PAGE_TITLES_PATCH = {
    [convoIntelPathResources.scorecards]: "Scorecard Templates",
    [convoIntelPathResources.insights]: "Insights",
    [`${convoIntelPathResources.scorecards}/new`]: "Set Up New Scorecard Template",
} as const;

// Description/subtitle overrides used where explanatory copy differs from base metadata.
export const CONVO_INTEL_PAGE_DESCRIPTIONS_PATCH = {
    [convoIntelPathResources.scorecards]: "Create and manage scorecards that can be used to evaluate conversations.",
    [convoIntelPathResources.moments]:
        "Manage the list of moments that Regal will use to automatically tag conversations.",
    [convoIntelPathResources.customAnalysis]:
        "Define custom data points and use AI to extract structured answers from transcripts.",
    [convoIntelPathResources.recordings]:
        "Search, view, and play back your last 30 days of call recordings and transcripts.",
} as const;
